import React from 'react';

import { SubscriptionEdit } from 'App/components/Subscriptions/SubscriptionsForm';
import { useCurrentUser } from 'Auth';

import {
  Avatar,
  Link,
  ListItemAvatar,
  ListItemText,
  TypographyList,
  TypographyListItem,
  Action,
  Actions,
  ListItem,
  Grid,
  List,
  Typography,
  Stack,
  makeStyles,
  Divider,
  MailOutlineIcon,
} from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';
import { DateValueFormatter } from '@gogame/intl-ts';

import { PAGES, SCHEDULE } from './constants';
import { useDeleteSubscription } from './data';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      height: '100%',
      overflow: 'auto',
    },
    avatar: {
      border: `1px solid ${theme.palette.divider}`,
      background: theme.palette.background.paper,
      color: theme.palette.text.secondary,
    },
    list: {
      paddingTop: 0,
    },
  };
});

const SubscriptionsList = ({ dense, data }) => {
  const classes = useStyles();
  const currentUser = useCurrentUser();
  const [childComponent, showChildComponent] = useChildComponent();
  const [deleteSubscription] = useDeleteSubscription();

  const handleEditRecipients = ({ id }) => {
    showChildComponent(SubscriptionEdit, {
      id,
    });
  };

  const handleDelete = (item) => {
    deleteSubscription(item);
  };

  return (
    <React.Fragment>
      <Stack className={classes.root}>
        {data?.count ? (
          <List dense={dense} className={classes.list}>
            {data?.rows.map((item) => (
              <>
                <ListItem
                  key={item?.id}
                  secondaryAction={
                    <Stack direction={'row'} spacing={1} alignItems={'center'}>
                      <Actions limit={0}>
                        <Action
                          label={'Edit'}
                          onClick={() => handleEditRecipients(item)}
                        />
                        <Action
                          label={'Delete'}
                          onClick={() => handleDelete(item)}
                        />
                      </Actions>
                    </Stack>
                  }
                >
                  <ListItemAvatar>
                    <Avatar className={classes.avatar}>
                      <MailOutlineIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Link href={'/v3' + item.queryString} target={'_blank'}>
                        <Typography variant={'body1'} lineClamp={2}>
                          {item.name}
                        </Typography>
                      </Link>
                    }
                    secondary={
                      <Stack
                        spacing={1}
                        direction={'row'}
                        alignItems={'center'}
                      >
                        <Typography variant={'overline'} display={'block'}>
                          {PAGES[item.page]}
                        </Typography>

                        <Typography>|</Typography>

                        <Typography variant={'overline'} display={'block'}>
                          {SCHEDULE[item.schedule.period]}
                        </Typography>

                        {item.schedule?.nextFireTime && (
                          <>
                            <Typography>|</Typography>
                            <Typography variant={'overline'} display={'block'}>
                              <DateValueFormatter
                                value={item.schedule.nextFireTime}
                                template={'LLL'}
                                timeZone={'local'}
                              />
                            </Typography>
                          </>
                        )}
                        <Typography>|</Typography>
                        <TypographyList
                          menuVariant={'overline'}
                          limit={1}
                          unitsLabel={
                            <Typography variant={'overline'}>
                              recipient(s)
                            </Typography>
                          }
                        >
                          {item.recipients?.map(({ name }, _i, arr) => (
                            <TypographyListItem variant={'overline'}>
                              {name === currentUser?.name && arr.length === 1
                                ? 'Me'
                                : name}
                            </TypographyListItem>
                          ))}
                        </TypographyList>
                      </Stack>
                    }
                  />
                </ListItem>
                <Divider />
              </>
            ))}
          </List>
        ) : (
          <Grid
            container
            spacing={3}
            alignItems={'center'}
            style={{ height: '100%' }}
          >
            <Grid item xs={12}>
              <Typography variant={'subtitle1'} align={'center'}>
                No records
              </Typography>
            </Grid>
          </Grid>
        )}
      </Stack>
      {childComponent}
    </React.Fragment>
  );
};

export default SubscriptionsList;
